// Pista del login (22/10/2026): un profe de Ipunto se dio de alta con su móvil y luego intentó entrar con
// «autoescuela ipunto». Si el login falla y lo tecleado NO tiene forma de móvil ni de email, se le recuerda qué es
// su usuario. Anti-enumeración: la pista depende SOLO de la FORMA de lo tecleado, nunca de si el usuario existe
// (se decide en el navegador, sin preguntar al servidor). Ficha: docs/features/alta-usuario-recordado-y-reset-en-chat.md

/** ¿Tiene forma de email? (algo@algo.algo, sin espacios) */
export function pareceEmail(v) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || "").trim());
}

/** ¿Tiene forma de móvil? Admite espacios, guiones, puntos, paréntesis, «+» y «00» delante (como c_login). */
export function pareceMovil(v) {
  const s = String(v || "").trim();
  if (!s || /[a-z@]/i.test(s)) return false;
  let c = s.replace(/[\s\-(). ]/g, "");
  if (/^00\d/.test(c)) c = `+${c.slice(2)}`;
  return /^\+?\d{9,15}$/.test(c);
}

/** true → enseñar «Tu usuario es el móvil o el email…». PURA. */
export function debePistaUsuario(v) {
  const s = String(v || "").trim();
  if (!s) return false;
  return !pareceEmail(s) && !pareceMovil(s);
}

/** "ca" con ?lang=ca (también «ca-ES»); si no, "es". PURA. */
export function loginLang(search) {
  const q = new URLSearchParams(search || "");
  return String(q.get("lang") || "").trim().toLowerCase().startsWith("ca") ? "ca" : "es";
}

export const PISTA_TEXT = {
  es: {
    pista: "Tu usuario es el móvil o el email con el que te diste de alta.",
    olvide: "¿Olvidaste tu contraseña?",
  },
  ca: {
    pista: "El teu usuari és el mòbil o el correu amb què et vas donar d'alta.",
    olvide: "Has oblidat la contrasenya?",
  },
};
